const API = process.env.REACT_APP_API_URL;

let reloginInFlight = null;

async function reloginViaTelegram() {
  // Single-flight: if 5 requests 401 at once, we do ONE re-login
  if (reloginInFlight) return reloginInFlight;

  reloginInFlight = (async () => {
    const tg = window.Telegram?.WebApp;
    const initData = tg?.initData;

    if (!initData) {
      throw new Error("NO_TELEGRAM_INITDATA");
    }

    const res = await fetch(`${API}/login/tma`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ initData }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data?.token) {
      throw new Error(data?.error || "TMA_RELOGIN_FAILED");
    }

    localStorage.setItem("token", data.token);
    return data.token;
  })();

  try {
    return await reloginInFlight;
  } finally {
    reloginInFlight = null;
  }
}

export async function apiFetch(path, options = {}) {
  const url = path.startsWith("http") ? path : `${API}${path}`;

  const token = localStorage.getItem("token");
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res1 = await fetch(url, { ...options, headers });

  if (res1.status !== 401) return res1;

  try {
    const newToken = await reloginViaTelegram();
    const res2 = await fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${newToken}`,
      },
    });
    return res2;
  } catch (e) {
    // Can't refresh -> clear token and bubble up
    localStorage.removeItem("token");
    throw e;
  }
}

export async function apiJson(path, options = {}) {
  const res = await apiFetch(path, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.error || data?.message || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
